import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, pluck } from 'rxjs/operators';

export function select<T>(selector: string) {
  return (o$: Observable<any>): Observable<T> => {
    return o$.pipe(
      pluck<any, T>(selector),
      filter(value => typeof value !== 'undefined'),
      distinctUntilChanged((prev, curr) => {
        return JSON.stringify(prev) === JSON.stringify(curr);
      })
    );
  };
}
